import { render } from "./poolAccount.vue?vue&type=template&id=20db87c1&scoped=true"
import script from "./poolAccount.vue?vue&type=script&lang=js"
export * from "./poolAccount.vue?vue&type=script&lang=js"

import "./poolAccount.vue?vue&type=style&index=0&id=20db87c1&scoped=true&lang=css"
import "./poolAccount.vue?vue&type=style&index=1&id=20db87c1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-20db87c1"

export default script